import axios from "axios";

// Përcaktojmë URL-në e API-së bazuar në mjedisin
const baseURL = process.env.REACT_APP_API_URL ;
const API_URL = `${baseURL}/chatbot`;

export const askChatbot = async (query, sessionId) => {
    // Sending both query and sessionId to the backend
    const response = await axios.post(API_URL, { query, sessionId });
    return response.data;
};